<template>
    <div id="header-rebrand" :class="{'active': showMobileMenu}">
        <a :href="regionRelativeUrl('/')">
            <img src="/images/erobella_logo_no_space.svg" alt="Logo" width="192" height="24"/>
        </a>

        <div class="navigation" :class="{'active': showMobileMenu}">
            <nav>
                <template v-for="nav in navigation">
                    <div class="nav-link-container">
                        <div class="nav-text-group">
                            <div v-if="nav.title && nav.title.toLowerCase().includes('livecam')"
                                 class="livecam-indicator"></div>
                            <span v-if="nav.navigateViaJS" @click="navigateViaJS(nav)" class="nav-link-clickable">
                                <span :class="nav.titleClass">{{ nav.title.toLowerCase() }}</span>
                            </span>
                            <a v-else :href="nav.path" :target="nav.target || '_self'">
                                <span :class="nav.titleClass">{{ nav.title.toLowerCase() }}</span>
                            </a>
                        </div>
                        <icon-component class="d-md-none" :icon="fa_chevron_right_bold()" width="10px" height="10px"/>
                    </div>
                </template>
            </nav>

            <a class="green-btn-whatsapp green-btn-whatsapp--mobile-only" :href="getWhatsappLink()">
                <span class="ml-2 whitespace-nowrap py-2">
                    {{ translate.account.needHelp }}
                </span>
                <IconComponent :icon="fa_whatsapp()" class="fa-whatsapp mx-2"></IconComponent>
            </a>

            <div class="navigation--actions">
                <template v-if="currentUser">
                    <a :href="regionRelativeUrl(NuxtRoutes.USERS.MESSAGES)" class="header-icon-link d-none d-md-flex">
                        <icon-component :icon="custom_message_bubble()" width="20px" height="20px"/>
                        <span v-if="conversationUnreadMessageCount" class="notification-counter notification-counter--header">
                            {{ conversationUnreadMessageCount < 100 ? conversationUnreadMessageCount : '99+' }}
                        </span>
                    </a>
                    <a v-if="isEscort" :href="regionRelativeUrl(NuxtRoutes.USERS.MEDIA_REPOSITORY)"
                       class="header-icon-link d-none d-md-flex">
                        <icon-component :icon="custom_media_image()" width="20px" height="20px"/>
                    </a>
                    <a :href="regionRelativeUrl('/users/account/')" class="logout-btn">
                        <icon-component :icon="custom_user()" width="16px" height="21px"/>
                    </a>
                    <a :href="regionRelativeUrl('/users/logout/')" class="logout-btn">
                        <span>{{ translate.login.logout }}</span>
                    </a>
                </template>
                <template v-else>
                    <!-- Desktop Buttons -->
                    <a :href="regionRelativeUrl('/users/login/')" class="d-none d-md-inline-flex btn-v2">
                        {{ translate.home.singIn }}
                    </a>
                    <a :href="regionRelativeUrl('/users/registration/')"
                       class="d-none d-md-inline-flex btn-v2 btn-v2-outline-grey">
                        {{ translate.home.singUp }}
                    </a>

                    <!-- Mobile Buttons -->
                    <a :href="regionRelativeUrl('/users/login/')"
                       class="d-md-none btn-v2 btn-v2-outline-grey btn-v2-xl whitespace-nowrap">
                        {{ translate.home.singIn }}
                    </a>
                    <a :href="regionRelativeUrl('/users/registration/')"
                       class="d-md-none btn-v2 btn-v2-gradient btn-v2-xl whitespace-nowrap">
                        {{ translate.home.createAccount }}
                    </a>
                </template>
            </div>
        </div>

        <div class="d-md-none header-navigation-mobile-actions">
            <template v-if="currentUser">
                <a :href="regionRelativeUrl(NuxtRoutes.USERS.MESSAGES)" class="header-icon-link">
                    <icon-component :icon="custom_message_bubble()" width="20px" height="20px"/>
                    <span v-if="conversationUnreadMessageCount" class="notification-counter notification-counter--header">
                        {{ conversationUnreadMessageCount < 100 ? conversationUnreadMessageCount : '99+' }}
                    </span>
                </a>
                <a v-if="isEscort" :href="regionRelativeUrl(NuxtRoutes.USERS.MEDIA_REPOSITORY)"
                   class="header-icon-link">
                    <icon-component :icon="custom_media_image()" width="20px" height="20px"/>
                </a>
                <a :href="regionRelativeUrl('/users/account/')" class="btn btn-xs-square">
                    <icon-component :icon="custom_user()" width="16px" height="21px"/>
                </a>
            </template>
            <hr/>
            <button class="btn btn-xs-square" @click="toggleMobileMenu()">
                <icon-component v-if="showMobileMenu" :icon="close()" width="14px" height="14px"/>
                <icon-component v-else :icon="hamburger()" width="18px" height="18px"/>
            </button>
        </div>
    </div>
</template>

<script>

import IconComponent from "@/components/global/IconComponent.vue";
import {
    close,
    custom_media_image,
    custom_message_bubble,
    custom_user,
    fa_chevron_right_bold,
    fa_whatsapp,
    hamburger,
} from "@/core/constants/icons";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import {getWhatsappLink} from "@/core/utils/helpers/whatsappHelper";
import {NuxtRoutes} from "@/core/constants/v2/nuxtRoutes";
import {mapState} from "vuex";
import userMixin from "@/components/mixins/userMixin";
import userNotificationMixin from "@/components/mixins/userNotificationMixin";

const data = () => {
    return {
        store: $store,
        showMobileMenu: false,
        NuxtRoutes,
    }
};

function toggleMobileMenu() {
    this.showMobileMenu = !this.showMobileMenu;
}

export default {
    data,
    methods: {
        close,
        hamburger,
        custom_user,
        custom_message_bubble,
        custom_media_image,
        fa_chevron_right_bold,
        toggleMobileMenu,
        regionRelativeUrl,
        fa_whatsapp,
        getWhatsappLink,
        navigateViaJS(link) {
            window.open(link.path, link.target || '_self');
        },
    },
    watch: {
        appIsReady: {
            immediate: true,
            handler(value) {
                if (typeof window === 'undefined') {
                    return;
                }

                if (value && this.currentUser) {
                    this.fetchUserNotifications();
                    this.listenWebsocketForNotificationCount();
                }
            }
        },
    },
    computed: {
        ...mapState(['currentUser', 'translate', 'regionData', 'settings', 'appIsReady', 'conversationUnreadMessageCount']),
        navigation() {
            return _.get(this.regionData, 'navBarLinks');
        },
    },
    mixins: [userMixin, userNotificationMixin],
    components: {
        IconComponent,
    },
}
</script>
